import { type ReactNode } from 'react'

import { ButtonRoot } from '@/components/common/Button'
import { FloatingHover } from '@/components/common/Floating'
import { Icon } from '@/components/icons/Icon'
import { type FloatingPlacementType } from '@/defs/floating'
import { cn } from '@/utils/commonUtil'

import { StatCommonFigure } from '../StatCommonFigure/StatCommonFigure'

import styles from './StatCommonBox.module.scss'

type Props = {
  children?: ReactNode
  height?: 'tall'
  label: ReactNode
  loading?: boolean
  popover?: ReactNode
  popoverPlacement?: FloatingPlacementType
}

export const StatCommonBox = ({ children, height, label, loading, popover, popoverPlacement }: Props) => {
  const value = loading ? <Icon name='spinner' /> : children || <StatCommonFigure>N/A</StatCommonFigure>

  return (
    <FloatingHover content={popover} placement={popoverPlacement} styled>
      <ButtonRoot className={cn(styles.container, { height, styles })}>
        <span className={styles.value}>{value}</span>
        <span className={styles.label}>{label}</span>
      </ButtonRoot>
    </FloatingHover>
  )
}
